import { useState } from 'react';
import { SlideMenu } from '../../../../common/components/slideMenu/SlideMenu';
import ClickableDiv from 'common/components/clickableDiv/ClickableDiv';
import { KWELLO_ICON, KwelloSvgIcon } from 'common/components/icon/KwelloSvgIcon';
import SideNavContainer from 'common/components/layouts/SideNav/SideNavContainer';

function TabletSideNav() {
  const [flyoutOpen, setFlyoutOpen] = useState<boolean>(false);

  const closeSidebar = () => {
    setFlyoutOpen(false);
  };

  return (
    <div className="mobile-header-container">
      <ClickableDiv onClick={() => setFlyoutOpen(!flyoutOpen)} className="tablet-hamburger">
        <KwelloSvgIcon icon={KWELLO_ICON.HAMBURGER_ICON} />
      </ClickableDiv>
      <SlideMenu
        showMenu={flyoutOpen}
        setShowMenu={setFlyoutOpen}
        height={'100vh'}
        slideDirection="left"
        hideBorder={true}
        className={'mobile-flyout-menu'}
        onClose={closeSidebar}
      >
        <SideNavContainer closeSidebar={closeSidebar} />
      </SlideMenu>
    </div>
  );
}

export default TabletSideNav;
